export enum statementTargets {
  download = "download",
  email = "email",
}
